const KEYBOARD_LAYOUT = {
  "shiftOff": {
    "192": "`",
    "49": "1",
    "50": "2",
    "51": "3",
    "52": "4",
    "53": "5",
    "54": "6",
    "55": "7",
    "56": "8",
    "57": "9",
    "48": "0",
    "189": "-",
    "187": "=",
    "81": "q",
    "87": "w",
    "69": "e",
    "82": "r",
    "84": "t",
    "89": "y",
    "85": "u",
    "73": "i",
    "79": "o",
    "80": "p",
    "219": "[",
    "221": "]",
    "65": "a",
    "83": "s",
    "68": "d",
    "70": "f",
    "71": "g",
    "72": "h",
    "74": "j",
    "75": "k",
    "76": "l",
    "186": ";",
    "222": "'",
    "220": "\\",
    "220": "<",
    "90": "z",
    "88": "x",
    "67": "c",
    "86": "v",
    "66": "b",
    "78": "n",
    "77": "m",
    "188": ",",
    "190": ".",
    "191": "/",
    "20": String.fromCharCode(2),
    "17": String.fromCharCode(5),
    "37": String.fromCharCode(8),
    "9": String.fromCharCode(9),
    "46": String.fromCharCode(12),
    "13": String.fromCharCode(13),
    "45": String.fromCharCode(14),
    "27": String.fromCharCode(15),
    "36": String.fromCharCode(17),
    "44": String.fromCharCode(18),
    "112": String.fromCharCode(22),
    "113": String.fromCharCode(23),
    "114": String.fromCharCode(24),
    "115": String.fromCharCode(25),
    "116": String.fromCharCode(26),
    "117": String.fromCharCode(27),
    "118": String.fromCharCode(28),
    "119": String.fromCharCode(29),
    "120": String.fromCharCode(30),
    "121": String.fromCharCode(31),
    "122": String.fromCharCode(16),
    "123": String.fromCharCode(21),
  },
  "shiftOn": {
    "192": "~",
    "49": "!",
    "50": "@",
    "51": "#",
    "52": "$",
    "53": "%",
    "54": "^",
    "55": "&",
    "56": "*",
    "57": "(",
    "48": ")",
    "189": "_",
    "187": "+",
    "81": "Q",
    "87": "W",
    "69": "E",
    "82": "R",
    "84": "T",
    "89": "Y",
    "85": "U",
    "73": "I",
    "79": "O",
    "80": "P",
    "219": "{",
    "221": "}",
    "65": "A",
    "83": "S",
    "68": "D",
    "70": "F",
    "71": "G",
    "72": "H",
    "74": "J",
    "75": "K",
    "76": "L",
    "186": ":",
    "222": "\"",
    "220": "|",
    "220": ">",
    "90": "Z",
    "88": "X",
    "67": "C",
    "86": "V",
    "66": "B",
    "78": "N",
    "77": "M",
    "188": "<",
    "190": ">",
    "191": "?",
  }
};

const KEYBOARD_LAYOUT_MARK = {
  "shiftOff": {
    "192": "`",
    "49": "1",
    "50": "2",
    "51": "3",
    "52": "4",
    "53": "5",
    "54": "6",
    "55": "7",
    "56": "8",
    "57": "9",
    "48": "0",
    "189": "-",
    "173": "-",
    "187": "=",
    "61": "=",
    "81": "q",
    "87": "w",
    "69": "e",
    "82": "r",
    "84": "t",
    "89": "y",
    "85": "u",
    "73": "i",
    "79": "o",
    "80": "p",
    "219": "[",
    "221": "]",
    "65": "a",
    "83": "s",
    "68": "d",
    "70": "f",
    "71": "g",
    "72": "h",
    "74": "j",
    "75": "k",
    "76": "l",
    "186": ";",
    "59": ";",
    "222": "'",
    "220": "\\",
    "90": "z",
    "88": "x",
    "67": "c",
    "86": "v",
    "66": "b",
    "78": "n",
    "77": "m",
    "188": ",",
    "190": ".",
    "191": "/",
    "20": String.fromCharCode(191),
    "20": String.fromCharCode(2),
    "17": String.fromCharCode(5),
    "37": String.fromCharCode(8),
    "9": String.fromCharCode(9),
    "46": String.fromCharCode(12),
    "13": String.fromCharCode(13),
    "45": String.fromCharCode(14),
    "27": String.fromCharCode(15),
    "36": String.fromCharCode(17),
    "44": String.fromCharCode(18),
    "112": String.fromCharCode(22),
    "113": String.fromCharCode(23),
    "114": String.fromCharCode(24),
    "115": String.fromCharCode(25),
    "116": String.fromCharCode(26),
    "117": String.fromCharCode(27),
    "118": String.fromCharCode(28),
    "119": String.fromCharCode(29),
    "120": String.fromCharCode(30),
    "121": String.fromCharCode(31),
    "122": String.fromCharCode(16),
    "123": String.fromCharCode(21),
  },
  "shiftOn": {
    "192": "~",
    "49": "!",
    "50": "@",
    "51": "#",
    "52": "$",
    "53": "%",
    "54": "^",
    "55": "&",
    "56": "*",
    "57": "(",
    "48": ")",
    "189": "_",
    "173": "_",
    "187": "+",
    "61": "+",
    "81": "Q",
    "87": "W",
    "69": "E",
    "82": "R",
    "84": "T",
    "89": "Y",
    "85": "U",
    "73": "I",
    "79": "O",
    "80": "P",
    "219": "{",
    "221": "}",
    "65": "A",
    "83": "S",
    "68": "D",
    "70": "F",
    "71": "G",
    "72": "H",
    "74": "J",
    "75": "K",
    "76": "L",
    "186": ":",
    "59": ":",
    "222": "\"",
    "220": "|",
    "90": "Z",
    "88": "X",
    "67": "C",
    "86": "V",
    "66": "B",
    "78": "N",
    "77": "M",
    "188": "<",
    "190": ">",
    "191": "?",
  }
};

export function getCharFromKeyboard(event) {
  const map = event.shiftKey === true
            ? KEYBOARD_LAYOUT["shiftOn"]
            : KEYBOARD_LAYOUT["shiftOff"];
  const keyCode = event.keyCode.toString(10);
  if (Object.keys(map).includes(keyCode)) {
    return map[keyCode];
  }
  return null;
}

export function getCharFromKeyboardMark(event) {
  const map = event.shiftKey === true
  ? KEYBOARD_LAYOUT_MARK["shiftOn"]
  : KEYBOARD_LAYOUT_MARK["shiftOff"];
  const keyCode = event.keyCode.toString(10);
  if (Object.keys(map).includes(keyCode)) {
    return map[keyCode];
  }
  return null;
}